import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import NoPermissions from './views/403.vue'
import Home from './views/Home.vue'

import UserData from './views/admin/data.vue'
import UserRole from './views/admin/role.vue'
import UserUser from './views/admin/user.vue'
import UserTemplate from './views/admin/template.vue'
import UserView from './views/admin/view.vue'
import UserCheck from './views/admin/check.vue'

import AdminDown from './views/user/download.vue'
import AdminFavor from './views/user/favorite.vue'
import AdminMulti from './views/user/multi.vue'
import AdminSingle from './views/user/single.vue'
import AdminSelect from './views/user/select.vue'
import AdminStored from './views/user/stored.vue'
import SSO from './views/sso.vue'

import UploadTemplate from './views/upload/template.vue'
import TUploadTemplate from './views/upload/tupload.vue'
import UploadResult from './views/upload/result.vue'

import Nodata from './views/Nodata.vue'
import Help from './views/user/help.vue'

export const rolesRouters = [
  {
    path: '/',
    component: Home,
    id: 1,
    meta: 1,
    name: '报告中心',
    children: [
      {
        path: '/select',
        component: AdminSelect,
        meta: 1,
        name: '报告查看'
      },
      // 	{
      // 	path: '/',
      // 	component: AdminSingle,
      // 	meta: 1,
      // 	name: 'Single Table',
      // }, {
      // 	path: '/multi',
      // 	component: AdminMulti,
      // 	meta: 1,
      // 	name: 'Multi Table',
      // }, {
      // 	path: '/stored',
      // 	component: AdminStored,
      // 	meta: 1,
      // 	name: 'Stored Procedure',
      // },
      {
        path: '/down',
        component: AdminDown,
        meta: 1,
        name: '报告下载'
      }
      // , {
      // 	path: '/favorite',
      // 	component: AdminFavor,
      // 	meta: 1,
      // 	name: 'Favorite',
      // }
    ]
  },
  {
    path: '/',
    component: Home,
    name: 'Admin',
    meta: 2,
    id: 2,
    children: [
      {
        path: '/user',
        component: UserUser,
        meta: 2,
        name: 'User'
      },
      {
        path: '/role',
        component: UserRole,
        meta: 2,
        name: 'Role'
      },
      {
        path: '/data',
        component: UserData,
        meta: 2,
        name: 'Data Source'
      },
      {
        path: '/aTemplate',
        component: UserTemplate,
        meta: 2,
        name: 'Upload Template'
      },
      {
        path: '/view',
        component: UserView,
        meta: 2,
        name: 'View Log'
      },
      {
        path: '/check',
        component: UserCheck,
        meta: 2,
        name: 'Check Rule'
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '上传中心',
    id: 3,
    meta: 3,
    children: [
      {
        path: '/tUpload',
        component: TUploadTemplate,
        meta: 3,
        name: '文件上传'
      },
      {
        path: '/template',
        component: UploadTemplate,
        meta: 3,
        name: '模板导入'
      },
      {
        path: '/result',
        component: UploadResult,
        meta: 3,
        name: '上传日志'
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '帮助中心',
    id: 4,
    meta: 4,
    children: [
      {
        path: '/help',
        component: Help,
        meta: 4,
        name: '帮助中心'
      }
    ]
  },
  {
    path: '/',
    component: Home,
    name: 'Admin',
    id: 5,
    meta: 5,
    children: [
      {
        path: '/no',
        component: Nodata,
        meta: 5,
        name: ''
      }
    ]
  }
]

export const defaultRouter = [
  {
    path: '/sso',
    component: SSO,
    name: 'login',
    hidden: true
  },
  {
  	path: '/login_t',
  	component: Login,
  	name: 'login',
  	hidden: true
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
  {
    path: '/403',
    component: NoPermissions,
    name: '',
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/routes.js